var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VForm',{staticClass:"manager-create-form",attrs:{"on-submit-async":_vm.submit},on:{"success":function (value){ return this$1.$emit('success',value); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var form = ref.form;
return [_c('UserCreateAndUpdateFormItems',{attrs:{"form":form,"is-create-form":true}}),_c('PeopleCreateAndUpdateFormItems',{attrs:{"form":form}}),_c('ManagerCreateAndUpdateFormItems',{attrs:{"form":form}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }